import getImage from "./../../ClinicHistory/ClinicEvent/components/PdfReports/GetImage";
import pdfMake from "pdfmake/build/pdfmake.js";
import moment from "moment";
import { calculateAgeParse } from "../../Utils/Patient";
import { formatNumber } from "../../Utils/Money";
import ReportsAPI from './../../Reports/api/reports_api';

const detailsPaymentPdf = async (data) => {
  pdfMake.fonts = {
    OpenSans: {
      normal: "OpenSans-Regular.ttf",
      bold: "OpenSans-Bold.ttf",
      italics: "OpenSans-Italic.ttf",
      bolditalics: "OpenSans-ExtraBoldItalic.ttf",
    },
    Merriweather: {
      normal: "Merriweather-Regular.ttf",
      bold: "Merriweather-Bold.ttf",
      italics: "Merriweather-Italic.ttf",
      bolditalics: "Merriweather-ExtraBoldItalic.ttf",
    },
    Roboto: {
      normal: "Roboto-Regular.ttf",
      bold: "Roboto-Bold.ttf",
      italics: "Roboto-Italic.ttf",
      bolditalics: "Roboto-BoldItalic.ttf",
    },
  };
  console.log("ComingToPDFPayment", data);

  const city = parseInt(data.profile.direccion.id_ciudad);
  const dept = parseInt(data.profile.direccion.id_dpto);
  const getCity = await ReportsAPI.loadCity(city);
  const getDepts = await ReportsAPI.loadDepartment();
  const deptoProfile = getDepts.find((depto) => depto.id === dept);
  const today = new Date();

  const header = {
    margin: [40, 10, 0, 0],
    layout: "noBorders",
    table: {
      widths: ["*", "*"],
      body: [
        [
          {
            image: await getImage(data.urlLogo),
            fit: [100, 40],
          },
          {
            text:
              data.profile.direccion.direccion +
              " " +
              data.profile.nombre +
              " \n Nit: " +
              data.profile.nit +
              " \n Teléfonos: " +
              data.profile.telefono1 +
              "-" +
              data.profile.telefono2,
            style: "head",
          },
        ],
      ],
    },
  };

  const documentDefinition = {
    pageSize: "LETTER",
    pageOrientation: "portrait",
    header: header,
    pageMargins: [40, 70, 30, 40],
    footer: function (currentPage, pageCount) {
      return {
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                text: "Página " + currentPage.toString() + " de " + pageCount,
                style: "head",
              },
              {
                text:
                  "Fecha Impresión: " + moment(today).format('DD-MM-YYYY'),
                style: "head",
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 0, 30, 5],
      };
    },
    content: [
      {text: "Pago No. " +  data.paymentInfo.id_pago,style: "headPayment", alignment: 'center', lineHeight: 2 },
      {text: "FACTURA " + data.invoiceInfo[0].num_fac_ter, style: "headPayment", alignment: 'center'},
      {
        table: {
            headerRows: 1,
            widths: [540],
            body: [
                [''],
                ['']
            ]
        },
        layout: 'headerLineOnly'
    },
    {
      table: {
        widths: ["*", "*"],
        body: [
          [{text: data.profile.nombre, style: "headPayment", alignment: 'center' }, {text: data.invoiceInfo[0].nombre_facturado, style: "headPayment", alignment: 'center' }],
          [{text: data.profile.direccion.direccion, style: "textStyle", alignment: 'center' }, {text: data.invoiceInfo[0].num_documento, style: "textStyle", alignment: 'center' }],
          [{text: 'NIT:' + data.profile.nit, style: "textStyle", alignment: 'center' },''],
          [{text: getCity[0].ciunom + '-' + deptoProfile.depnom, style: "textStyle", alignment: 'center' },''],
        ],
      },
      layout: "noBorders",
      margin: [20, 10, 0, 10],
    },
    {
      text:
        "Recibo de Pago",
      style: "headPayment",
      alignment: 'center'
    },
    {
      table: {
          headerRows: 1,
          widths: [540],
          body: [
              [''],
              ['']
          ]
      },
      layout: 'headerLineOnly'
  },
  {
    table: {
      widths: ["auto", "*", '*'],
      body: [
        [{text: 'Fecha de Pago: ', style: "headPayment", alignment: 'left' }, {text: moment(data.paymentInfo.fecha_pago).format('DD-MM-YYYY'), style: "textStyle" }, ''],
        [{text: 'Modo de Pago: ', style: "headPayment", alignment: 'left' }, {text: data.paymentInfo.forma_pago, style: "textStyle"}, ''],
      ],
    },
    layout: "noBorders",
    margin: [20, 10, 0, 10],
  },
  {
    table: {
        headerRows: 1,
        widths: [540],
        body: [
            [''],
            ['']
        ]
    },
    layout: 'headerLineOnly'
},
{
  text:
    "Importe Total: $" + formatNumber(data.paymentInfo.importe) ,
  style: "headPayment",
  alignment: 'left',
  margin: [20, 10, 0, 10],
},
{
  text:
    "Resumén del Pago",
  style: "headPayment",
  margin: [0, 50, 0, 10],
  alignment: 'left'
},
{
  table: {
    headerRows: 1,
    widths: ["*", "*", '*', '*', '*'],
    body: [
      [{text: 'Nro. Factura ', style: "headResumenPayment" }, {text: 'Fecha de la Factura', style: "headResumenPayment" }, {text: 'Total de la Factura', style: "headResumenPayment" }, {text: 'Importe del Pago', style: "headResumenPayment" }, {text: 'Importe a Pagar', style: "headResumenPayment" }],
      [{text: data.paymentInfo.num_fac_ter, style: "textStyle" }, {text: moment(data.invoiceInfo[0].fecha_emision).format('DD-MM-YYYY'), style: "textStyle"}, {text: '$' + formatNumber(data.totalInvoice), style: "textStyle"}, {text: '$' + formatNumber(data.paymentInfo.importe), style: "textStyle"}, {text: '$' + formatNumber(data.incomeToPay), style: "textStyle"}],
    ],
  },
  layout: "headerLineOnly",
  margin: [0, 10, 5, 10],
},
    ],
    styles: {
      headPayment: {
        fontSize: 12,
        bold: true,
      },
      headResumenPayment: {
        fontSize: 10,
        bold: true,
      },
      head: {
        fontSize: 7,
        bold: true,
        alignment: "left",
      },
      tableheader: {
        fontSize: 11,
        bold: true,
      },
      textStyle: {
        fontSize: 10,
      },
      tableTexStyle: {
        fontSize: 8,
        alignment: "left",
      },
      foter: {
        alignment: "center",
        fontSize: 6,
      },
      medicStyle: {
        margin: [0, 5, 0, 0],
        fontSize: 10,
        alignment: "left",
      },
    },
  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.getDataUrl(function (outDoc) {
    document.getElementById("pdfV").src = outDoc;
  });

  //pdfMake.createPdf(documentDefinition).open();
};
export default detailsPaymentPdf;
